

export default function Banner({image}) {
    return (
        <img src={image} alt="Banner" className="w-full mt-16" />
    );
};